import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import InsertLinkIcon from "./icons/insert-link.svg";
import InsertLinkCommand from "./insertlinkcommand";
import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import { 
  enableDisableKeywordOption,
  checkForWhiteSpace,
  checkSelectedComments,
  checkSelectionIncludesComments,
  checkForMedia, 
  isSingleSpanSelected ,
  CkeditorConstants,
  checkForTable,
  checkForFigCaption
} from "../../src/utils";
export default class InsertLinkUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add("insertlink", new InsertLinkCommand(editor));
    let linkInsertOptions = CkeditorConstants.INSERT_LINK_OPTIONS;

    editor.ui.componentFactory.add("insertlink", (locale) => {
      let dropdownView = createDropdown(locale);
      const command = editor.commands.get("insertlink");
      dropdownView.bind("isEnabled").to(command);

      dropdownView.id = "insertlink";

      dropdownView.buttonView.set({
        icon: InsertLinkIcon,
        tooltip: "Add / Edit links",
        class: "insertLinkIcon"
      });

      this.listenTo(this.editor.editing.view.document, "click", (event, data) => {
        const objForFragment = CkeditorConstants.INSERT_LINK_FRAGMENT_OPTION;

        linkInsertOptions = linkInsertOptions.filter(option => option.id !== CkeditorConstants.LINK_TO_FRAGMENT_ID);

        if (this.editor.config.get('type') !== CkeditorConstants.MINI_EDITOR && 
        localStorage.getItem(CkeditorConstants.localStorageItem.LINK_TO_FRAGMENT_AVAILABLE) !== null) {
          const index = 1;
          linkInsertOptions = [
            ...linkInsertOptions.slice(0, index),
            objForFragment,
            ...linkInsertOptions.slice(index)
          ];
        }
        addListToDropdown(
          dropdownView,
          getDropdownOptionsDefinitions(linkInsertOptions)
        );
      });

      dropdownView.buttonView.on('change', () => {
        const dropdownPanel = dropdownView.element.querySelector('.ck-dropdown__panel');
        if (dropdownPanel) {
          while (dropdownPanel.firstChild && dropdownPanel.children.length > 1) {
            dropdownPanel.removeChild(dropdownPanel.firstChild);
          }
        }
      });

      dropdownView.on("change:isOpen", () => {
        const getListElement = (listElementId) => {
          return editor.ui.view.toolbar.items._items.find(f => f.id === "insertlink")
            .listView.items._items.find(f => f?.children._items.find(i => i.id == listElementId))
            ?.children._items[0];
        }

        const element = getListElement("webemaillink");

        const otherDocumentElement = getListElement("linktoanotherdocument");
        
        const linktotextoutsidethisdocument = getListElement("linktotextoutsidethisdocument");

        element.isEnabled = otherDocumentElement.isEnabled = !enableDisableKeywordOption(editor);

        if(linkInsertOptions.find(obj => obj.id === CkeditorConstants.LINK_TO_FRAGMENT_ID)){
          const linktotextwithinthisdocument = getListElement(CkeditorConstants.LINK_TO_FRAGMENT_ID);
          linktotextwithinthisdocument.isEnabled = !enableDisableKeywordOption(editor) && !editor.model.document.selection.isCollapsed && !checkForMedia(editor)
          && !checkForWhiteSpace(editor)
          && !checkSelectedComments(editor)
          && !checkSelectionIncludesComments(editor)
          && isSingleSpanSelected(editor) && !checkForTable(editor) && !checkForFigCaption(editor);
        }
        
        linktotextoutsidethisdocument.isEnabled = false;

        editor.commands.get("insertwebemaillink").isEnabled = true;

        const selection = editor.model.document.selection;
        const ranges = selection.getRanges();

        for (const range of ranges) {
          for (const item of range.getItems()) {
            if(item.name) {
              if(item._children && 
                  item._children._nodes && 
                  item._children._nodes[0] &&
                  typeof item._children._nodes[0]._data !== "string" ){
                      editor.commands.get("insertwebemaillink").isEnabled = false;
                      break;
              }
            } else if (typeof item.data === "string" && item.data !== "") {
              editor.commands.get("insertotherdocumentlink").isEnabled = true;
            }
          }
        }
      });

      dropdownView.on("execute", (eventInfo) => {
        editor.execute("insertlink", eventInfo);
      });

      return dropdownView;
    });
  }
}

function getDropdownOptionsDefinitions(linkInsertOptions) {
  const itemDefinitions = new Collection();
  for (const linkInsertOption of linkInsertOptions) {
    let definition = {
      type: "button",
      model: new Model({
        id: linkInsertOption.id,
        label: linkInsertOption.label,
        withText: true,
        tooltip: true,
        class: "insertLink",
      }),
    };

    // Add the item definition to the collection.
    itemDefinitions.add(definition);
  }
  return itemDefinitions;
}
